export type FilterValuePredicate = (value: unknown, key: string) => boolean;

export const cleanFilter = <TState extends Record<string, unknown>>(
  filter: TState,
  ...predicates: FilterValuePredicate[]
): TState =>
  Object.fromEntries(
    Object.entries(filter).filter(([key, value]) =>
      predicates.every((predicate) => predicate(value, key)),
    ),
  ) as TState;

export const isNotEmptyArray = (value: unknown): boolean =>
  !Array.isArray(value) || value.length > 0;

export const isNotFalse = (value: unknown): boolean => value !== false;

export const isNotUndefined = (value: unknown): boolean => value !== undefined;

export const isNotUndefinedOrEmptyString = (value: unknown): boolean =>
  value !== undefined && value !== '';
